import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { BRAND, whatsappLink } from '../data/brand';

const navItems = [
  { label:'Home',       path:'/' },
  { label:'Rooms',      path:'/rooms' },
  { label:'Facilities', path:'/services' },
  { label:'Gallery',    path:'/gallery' },
  { label:'About',      path:'/about' },
  { label:'FAQ',        path:'/faq' },
  { label:'Contact',    path:'/contact' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen]   = useState(false);
  const [searchOpen, setSearchOpen]   = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [scrolled, setScrolled]       = useState(false);
  const { cartCount }                  = useCart();
  const location                       = useLocation();

  useEffect(() => {
    const s = () => setScrolled(window.scrollY > 100);
    window.addEventListener('scroll', s);
    return () => window.removeEventListener('scroll', s);
  }, []);

  useEffect(() => { setMobileOpen(false); setSearchOpen(false); }, [location]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const isActive = p => p === '/' ? location.pathname === '/' : location.pathname.startsWith(p);

  const Logo = ({ height = 52 }) => (
    <img src={BRAND.logo} alt={BRAND.name} style={{ height, objectFit:'contain', display:'block' }} />
  );

  return (
    <header className="main-header header-style-five">

      {/* ── Top Bar ── */}
      <div className="header-top">
        <div className="header-top-inner">
          <div className="top-left">
            <ul className="social-icon-one">
              <li><a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a></li>
              <li><a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a></li>
              <li><a href={whatsappLink()} aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a></li>
              <li><a href="#" aria-label="Twitter"><i className="fab fa-x-twitter"></i></a></li>
            </ul>
          </div>
          <div className="top-right">
            <span>
              <i className="fas fa-phone icon"></i>
              <a href={`tel:${BRAND.phones[0].tel}`} style={{ color:'rgba(255,255,255,0.75)', textDecoration:'none' }}>{BRAND.phones[0].label}</a>
              &nbsp;/&nbsp;
              <a href={`tel:${BRAND.phones[1].tel}`} style={{ color:'rgba(255,255,255,0.75)', textDecoration:'none' }}>{BRAND.phones[1].label}</a>
            </span>
            <span><i className="fas fa-location-dot icon"></i> {BRAND.addressShort}</span>
          </div>
        </div>
      </div>

      {/* ── Header Lower ── */}
      <div className="header-lower">
        <div className="main-box">
          <div className="logo-box">
            <Link to="/"><Logo height={58} /></Link>
          </div>

          <nav className="main-nav">
            <ul className="nav-list">
              {navItems.map(item => (
                <li key={item.path} className={isActive(item.path) ? 'active' : ''}>
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="header-icons">
            <button className="icon-btn" aria-label="Search" onClick={() => setSearchOpen(true)}>
              <i className="fas fa-magnifying-glass"></i>
            </button>
            <Link to="/cart" className="icon-btn cart-icon-btn" aria-label="Cart">
              <i className="fas fa-cart-shopping"></i>
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </Link>
            <button className="icon-btn hamburger" onClick={() => setMobileOpen(true)}>
              <i className="fas fa-bars"></i>
            </button>
          </div>
        </div>
      </div>

      {/* ── Sticky Header ── */}
      <div className={"sticky-header" + (scrolled ? ' visible' : '')}>
        <div className="sticky-inner">
          <Link to="/"><Logo height={42} /></Link>
          <nav className="main-nav">
            <ul className="nav-list">
              {navItems.map(item => (
                <li key={item.path} className={isActive(item.path) ? 'active' : ''}>
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className="header-icons">
            <button className="icon-btn" onClick={() => setSearchOpen(true)}><i className="fas fa-magnifying-glass"></i></button>
            <Link to="/cart" className="icon-btn cart-icon-btn">
              <i className="fas fa-cart-shopping"></i>
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </Link>
            <button className="icon-btn hamburger" onClick={() => setMobileOpen(true)}><i className="fas fa-bars"></i></button>
          </div>
        </div>
      </div>

      {/* ── Mobile Overlay ── */}
      {mobileOpen && <div className="mobile-overlay" onClick={() => setMobileOpen(false)} />}
      <div className={"mobile-drawer" + (mobileOpen ? ' open' : '')}>
        <div className="drawer-head">
          <Link to="/" onClick={() => setMobileOpen(false)}><Logo height={44} /></Link>
          <button className="drawer-close" onClick={() => setMobileOpen(false)}><i className="fas fa-times"></i></button>
        </div>
        <ul className="drawer-nav">
          {navItems.map(item => (
            <li key={item.path} className={isActive(item.path) ? 'active' : ''}>
              <Link to={item.path} onClick={() => setMobileOpen(false)}>{item.label}</Link>
            </li>
          ))}
        </ul>
        <div className="drawer-footer">
          <p><i className="fas fa-phone me-2"></i><a href={`tel:${BRAND.phones[0].tel}`} style={{ color:'rgba(255,255,255,0.7)' }}>{BRAND.phones[0].label}</a></p>
          <p><i className="fas fa-phone me-2"></i><a href={`tel:${BRAND.phones[1].tel}`} style={{ color:'rgba(255,255,255,0.7)' }}>{BRAND.phones[1].label}</a></p>
          <p><i className="fas fa-envelope me-2"></i><a href={`mailto:${BRAND.email}`} style={{ color:'rgba(255,255,255,0.7)', fontSize:12 }}>{BRAND.email}</a></p>
          <ul className="social-icon-one mt-3">
            <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
            <li><a href={whatsappLink()}><i className="fab fa-whatsapp"></i></a></li>
            <li><a href="#"><i className="fab fa-instagram"></i></a></li>
          </ul>
        </div>
      </div>

      {/* ── Search Overlay ── */}
      {searchOpen && (
        <div className="search-overlay" onClick={() => setSearchOpen(false)}>
          <div className="search-modal" onClick={e => e.stopPropagation()}>
            <button className="search-close" onClick={() => setSearchOpen(false)}><i className="fas fa-times"></i></button>
            <p className="search-label">What are you looking for?</p>
            <form className="search-form" onSubmit={e => { e.preventDefault(); setSearchOpen(false); }}>
              <input autoFocus type="search" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search rooms, facilities…" />
              <button type="submit"><i className="fas fa-search"></i></button>
            </form>
          </div>
        </div>
      )}
    </header>
  );
}
